import api from './api';

class AdminFeeService {
  // **APIs solo para admins**
  
  // Crear nueva configuración de fee
  async createFeeConfiguration(feeData) {
    const response = await api.post('/api/budget/admin-fee-configurations', feeData);
    return response.data?.data || response.data;
  }

  // Obtener todas las configuraciones (admin)
  async getAllFeeConfigurations() {
    const response = await api.get('/api/budget/admin-fee-configurations');
    return response.data?.data || response.data;
  }

  // Obtener estadísticas
  async getFeeStats() {
    const response = await api.get('/api/budget/admin-fee-configurations/stats');
    return response.data;
  }

  // Actualizar configuración
  async updateFeeConfiguration(id, feeData) {
    const response = await api.patch(`/api/budget/admin-fee-configurations/${id}`, feeData);
    return response.data;
  }

  // Activar/Desactivar configuración
  async toggleFeeConfiguration(id) {
    const response = await api.patch(`/api/budget/admin-fee-configurations/${id}/toggle-active`);
    return response.data;
  }

  // Eliminar configuración
  async deleteFeeConfiguration(id) {
    const response = await api.delete(`/api/budget/admin-fee-configurations/${id}`);
    return response.data;
  }

  // **APIs para todos los usuarios**
  
  // Obtener configuraciones activas
  async getActiveFeeConfigurations() {
    const response = await api.get('/api/budget/admin-fee-configurations/active');
    return response.data?.data || response.data;
  }

  // Obtener configuración por ID
  async getFeeConfigurationById(id) {
    const response = await api.get(`/api/budget/admin-fee-configurations/${id}`);
    return response.data;
  }

  // *** FUNCIÓN PRINCIPAL: Obtener fees válidos para una orden ***
  async getValidFeesForOrder(clientId, orderStartDate, orderEndDate, grossInvestment = null) {
    const params = {
      clientId,
      orderStartDate: orderStartDate.toISOString().split('T')[0], // YYYY-MM-DD
      orderEndDate: orderEndDate.toISOString().split('T')[0],
      ...(grossInvestment && { grossInvestment })
    };

    const response = await api.get('/api/budget/admin-fee-configurations/valid-for-order', { params });
    
    // El backend devuelve { success: true, data: [...], meta: {...} }
    // Necesitamos extraer solo el array de configuraciones
    if (response.data && response.data.success && response.data.data) {
      return response.data.data; // ← Extraer el array de configuraciones
    }
    
    return response.data; // fallback por si cambia el formato
  }

  // **Utilidades helper**
  
  // Formatear tipos de aplicación para UI
  formatAppliesTo(appliesTo) {
    const formats = {
      'ALL': 'Todos los clientes',
      'VIP_CLIENTS': 'Clientes VIP',
      'PREMIUM_CLIENTS': 'Clientes Premium',
      'SMALL_CLIENTS': 'Clientes Pequeños',
      'SPECIFIC_CLIENTS': 'Clientes Específicos'
    };
    return formats[appliesTo] || appliesTo;
  }

  // Formatear tipo de fee para UI
  formatFeeType(feeType) {
    return feeType === 'percentage' ? 'Porcentaje' : 'Monto Fijo';
  }

  // Calcular fee basado en configuración
  calculateFee(config, grossInvestment) {
    if (!config || !grossInvestment) return 0;
    
    if (config.feeType === 'percentage') {
      return (grossInvestment * config.feeValue) / 100;
    } else {
      return config.feeValue;
    }
  }

  // Validar si una configuración está vigente
  isConfigurationValid(config, currentDate = new Date()) {
    const validFrom = new Date(config.validFrom);
    const validTo = new Date(config.validTo);
    return currentDate >= validFrom && currentDate <= validTo;
  }

  // Obtener opciones para dropdown de "Aplica a"
  getAppliesToOptions() {
    return [
      { value: 'ALL', label: 'Todos los clientes', icon: 'users' },
      { value: 'VIP_CLIENTS', label: 'Clientes VIP', icon: 'crown' },
      { value: 'PREMIUM_CLIENTS', label: 'Clientes Premium', icon: 'star' },
      { value: 'SMALL_CLIENTS', label: 'Clientes Pequeños', icon: 'user' },
      { value: 'SPECIFIC_CLIENTS', label: 'Clientes Específicos', icon: 'user-check' }
    ];
  }

  // Obtener opciones para dropdown de tipo de fee
  getFeeTypeOptions() {
    return [
      { value: 'percentage', label: 'Porcentaje (%)', icon: 'percent' },
      { value: 'amount', label: 'Monto Fijo ($)', icon: 'dollar-sign' }
    ];
  }
}

const adminFeeService = new AdminFeeService();
export default adminFeeService; 